<!-- 验收表单 -->
<template>
    <layui-collapse ref="collapse" class="requestForm">
        <div class="layui-colla-item">
            <h2 class="layui-colla-title">服务单验收信息</h2>
            <div class="layui-colla-content layui-show">
                <div class="layui-form-item-two layui-form-column">
                  <div class="layui-form-colun-inner">
                    <div class="layui-form-item-left">
                        <div class="layui-form-item">
                            <label class="layui-form-label">验收结果：</label>
                            <label class="layui-form-label right" v-if="!editable">{{editRow.ACCEPTANCE_TIME ? editRow.ACCEPTANCE_RESULT_DESC : ''}}</label>
                            <div class="layui-input-inline" style="width: 60%" v-if="editable">
                                <layui-radio v-model="editRow.ACCEPTANCE_RESULT" name="ACCEPTANCE_RESULT">
                                  <input type="radio" value="1" title="通过" />
                                  <input type="radio" value="0" title="不通过" />
                                </layui-radio>
                            </div>
                        </div>
                        <div class="layui-form-item" v-if="!editable">
                            <label class="layui-form-label">验收人员：</label>
                            <label class="layui-form-label right">{{editRow.ACCEPTANCE_TIME ? editRow.MANAGER_NAME : ''}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">验收时间：</label>
                            <label class="layui-form-label right" v-if="!editable">{{editRow.ACCEPTANCE_TIME}}</label>
                            <div class="layui-input-inline" style="width: 60%" v-if="editable">
                                <layui-datetime :showNewDate="true" name="ACCEPTANCE_TIME" v-model="editRow.ACCEPTANCE_TIME" placeholder="验收时间"></layui-datetime>
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">验收意见：</label>
                            <label class="layui-form-label right textarea" v-if="!editable">{{editRow.ACCEPTANCE_COMMENTS}}</label>
                            <div class="layui-input-inline" style="width:60%" v-if="editable">
                                <textarea v-model="editRow.ACCEPTANCE_COMMENTS" name="ACCEPTANCE_COMMENTS" class="layui-textarea"></textarea>
                            </div>
                        </div>

                    </div>
                    <div class="layui-form-item-right" v-if="editRow.ACCEPTANCE_RESULT == '0'">
                        <div class="layui-form-item">
                            <label class="layui-form-label">整改期限：</label>
                            <label class="layui-form-label right" v-if="!editable">{{editRow.ACCEPTANCE_RECTIFY_START}} - {{editRow.ACCEPTANCE_RECTIFY_END}}</label>
                            <div class="layui-input-inline" style="width: 29.5%;" v-if="editable">
                                <layui-datetime v-model="editRow.ACCEPTANCE_RECTIFY_START" name="ACCEPTANCE_RECTIFY_START" placeholder="开始时间"></layui-datetime>
                            </div>
                            <div class="layui-input-inline" style="width: 29.9%;" v-if="editable">
                                <layui-datetime v-model="editRow.ACCEPTANCE_RECTIFY_END" name="ACCEPTANCE_RECTIFY_END" placeholder="结束时间"></layui-datetime>
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">整改要求：</label>
                            <label class="layui-form-label right textarea" v-if="!editable">{{editRow.ACCEPTANCE_RECTIFY_REQUIRE}}</label>
                            <div class="layui-input-inline" style="width:60%" v-if="editable">
                                <textarea v-model="editRow.ACCEPTANCE_RECTIFY_REQUIRE" name="ACCEPTANCE_RECTIFY_REQUIRE" class="layui-textarea"></textarea>
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">整改建议：</label>
                            <label class="layui-form-label right textarea" v-if="!editable">{{editRow.ACCEPTANCE_RECTIFY_SUGGESTION}}</label>
                            <div class="layui-input-inline" style="width:60%" v-if="editable">
                                <textarea v-model="editRow.ACCEPTANCE_RECTIFY_SUGGESTION" name="ACCEPTANCE_RECTIFY_SUGGESTION" class="layui-textarea"></textarea>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="layui-form-bottom">
                    <div class="layui-form-item">
                            <label class="layui-form-label">附件：</label>
                            <div class="layui-input-inline" style="width:80%">
                                <layui-listfileupload
                                    targetEl=".requestForm"
                                    v-model="editRow.ACCEPTANCE_FILE_FS"
                                    :enabled="editable">
                                     <template  slot-scope="{scope}" v-if="editable">
                                        <div class="layui-upload">
                                            <button type="button" @click="scope.upload()" class="layui-upload-btn"><i class="layui-icon layui-icon-addition"></i> 添加文件</button>
                                            <small class="layui-upload-muted">（单个不超过50M）</small>
                                        </div>
                                    </template>
                                </layui-listfileupload>
                            </div>
                        </div>
                  </div>
                </div>
            </div>
        </div>
    </layui-collapse>
</template>
<script>
    export default {
        props: {
            editRow: {
                default: () => ({}),
                type: Object
            },
            enabled: {
                type: Boolean,
                default: false,
            }
        },
        data () {
            return {
                editable:false,
            }
        },
        mounted () {
            this.$nextTick(()=> {
                this.editable = this.enabled;
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/workOrder/detailForm/acceptanceForm.vue